<script lang="ts">
	import type { ModalProps } from '../utils.svelte';

	import { back_button_state } from '../states/back_button_state';
	import { utils } from '../utils.svelte';
	import { onDestroy } from 'svelte';
	import { toast } from '../toast';

	let {
		disable_close_onclick_outside = false,
		onclose,
		open = $bindable(false),
		children,
		level = 1,
		class: parent_classes,
		forced_classes
	}: ModalProps = $props();

	let dialog: HTMLDialogElement;

	function close_on_escape(event: any) {
		if (event.key === 'Escape' && !disable_close_onclick_outside) {
			handle_close();
		}
	}

	function handle_close() {
		onclose?.();
		dialog?.close();
		open = false;
		toast.show_notifications_popover();
		back_button_state.unregister(handle_close);
	}

	function handle_open() {
		dialog?.showModal();
		toast.show_notifications_popover();
		back_button_state.register(handle_close);
	}

	function calculate_dialog_width() {
		switch (level) {
			case 1:
				return 'w-[98%] md:w-[85%] lg:w-[75%]';
			case 2:
				return 'w-[88%] md:w-[75%] lg:w-[65%] max-w-2xl';
			case 3:
				return 'w-[78%] md:w-[65%] lg:w-[55%]';
		}
	}

	$effect(() => {
		if (dialog && open) handle_open();
		else handle_close();
	});

	onDestroy(() => {
		onclose?.();
		open = false;
		back_button_state.unregister(handle_close);
	});
</script>

<svelte:window onkeydown={close_on_escape} />

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<!-- svelte-ignore a11y_no_static_element_interactions -->

<dialog
	id="modal_dialog"
	class={utils.cn(forced_classes ? forced_classes : calculate_dialog_width(), parent_classes, 'm-auto')}
	bind:this={dialog}
	onclose={handle_close}
	onkeydown={(e) => e.key === 'Escape' && disable_close_onclick_outside && e.preventDefault()}
	onclick={(e) => {
		if (e.target !== dialog) return;
		if (!disable_close_onclick_outside) handle_close();
	}}
>
	<div onclick={(e) => e.stopPropagation()}>
		{@render children?.()}
	</div>
</dialog>

<style>
	dialog::backdrop {
		background: rgba(0, 0, 0, 0.5);
	}

	dialog {
		padding: 0px;
		border: none;
		border-radius: 5px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
		/* position: relative; */
	}

	/* dialog {
		border-radius: 0.4em;
		border: none;
		padding: 0;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
		z-index: 1000;
	} */
	/* dialog > div {
		padding: 0.5em;
	} */
	dialog[open] {
		animation: zoom 0.3s cubic-bezier(0.16, 1, 0.3, 1);
	}
	@keyframes zoom {
		from {
			transform: scale(0.95);
		}
		to {
			transform: scale(1);
		}
	}
	dialog[open]::backdrop {
		animation: fade 0.2s ease-out;
	}
	@keyframes fade {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	button {
		display: block;
	}
</style>
